<template>
  <span />
</template>

<script>
import { CountUp } from 'countup.js'

const defaultOptions = {
  startVal: 0, // number to start at (0)
  decimalPlaces: 2, // number of decimal places (2)
  duration: 2, // animation duration in seconds (2)
  separator: ',', // grouping separator (',')
  decimal: '.' // decimal ('.')
}

export default {
  name: 'BaseNumber',

  props: {
    value: {
      type: Number,
      required: true
    },
    delay: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  data () {
    return {
      instance: null
    }
  },

  mounted () {
    this.create(this.value)

    this.$watch(() => this.value, (currentValue, previousValue) => {
      if (currentValue !== previousValue) {
        this.update(currentValue)
      }
    }, { immediate: false })
  },

  beforeDestroy () {
    this.instance = null
  },

  methods: {
    create (value) {
      if (this.instance === null) {
        this.instance = new CountUp(this.$el, value, Object.assign({ }, defaultOptions, this.options))

        setTimeout(() => this.instance.start(), this.delay)
      }
    },

    update (value) {
      if (this.instance) {
        return this.delay > 0 ? setTimeout(() => this.instance.update(value), this.delay) : this.instance.update(value)
      }

      this.create(value)
    }
  }
}
</script>
